export default __webpack_public_path__ + "static/media/question-secondary.00f7bc31.svg";